export enum RebalanceProcessStatus {
  Entry = 0,
  Process = 1,
  Waiting = 2,
  PlanExecution = 3,
  PlannedExecution = 4,
}
